<onboarding-wizard *ngIf="isOnboardingActive"></onboarding-wizard>
<div *ngIf="!isKanbanModuleAcite" class="m-subheader">
    <div class="d-flex align-items-center">
        <div class="mr-auto offset-1">
            <h3 id="welcomeText" class="m-subheader__title" i18n="@@5056f9cc2bd0f605a3bac1eeae2bb25c3a0779d7">Dobrodošli v aplikaciji eAmbulanta!</h3>
        </div>
    </div>
</div>
<div class="h-100">
    <index-kanban *ngIf="isKanbanModuleAcite"></index-kanban>
    <ng-container *ngIf="!isKanbanModuleAcite">
        <div *ngxPermissionsOnly="['caleandar_view_terms__visible']" class="row justify-content-center">
            <div class="col-lg-5 col-12 pr-2 pl-2 m-2">
                <app-time-list
                    [grayHeader]="false"
                    [title]="'Termini'"
                    [fullHeight]="'true'"
                    [hiddeTimeButtons]="'true'"
                    [allData]="resultList | async"
                    (onTimeChange)="loadForTime($event)"
                    (onClickElement)="openReservation($event)"
                    class="app-time-list-t-t"
                ></app-time-list>
            </div>
            <div class="col-lg-5 col-12 pr-2 pl-2 m-2">
                <div *ngxPermissionsOnly="['menu_main_tasks__Visible']" class="m-portlet m-portlet--full-height">
                    <div class="m-portlet__head">
                        <div class="m-portlet__head-caption">
                            <div class="m-portlet__head-title">
                                <h3 class="m-portlet__head-text" i18n="@@59d54ed07f3cd5b365dca097393bbba31f931ad3">Opravila</h3>
                            </div>
                        </div>
                        <div class="m-portlet__head-tools">
                            <ul
                                role="tablist"
                                class="nav nav-pills nav-pills--brand m-nav-pills--align-right m-nav-pills--btn-pill m-nav-pills--btn-sm"
                            ></ul>
                        </div>
                    </div>
                    <div class="m-portlet__body">
                        <app-index-tasks></app-index-tasks>
                    </div>
                </div>
            </div>
        </div>
        <div class="offset-1">
            <com-app-version></com-app-version>
        </div>
    </ng-container>
</div>
